'use client'

import useIsMobile from '@/hooks/useIsMobile'
import { NoticeBannerProps } from '@/widgets/landing-page-widgets/NoticeBanner/schema'
import Image from 'next/image'
import styles from './noticebanner.module.css'

const _window = typeof window !== 'undefined' ? window : null

const NoticeBanner = ({ noticeBannerData }: { noticeBannerData: NoticeBannerProps }) => {
  // ✅ Add null/undefined check before destructuring
  if (!noticeBannerData) return null
  
  const { banner, mWebBanner, urlToOpen } = noticeBannerData
  const { isMobile } = useIsMobile()

  const handleBannerClick = () => {
    if (urlToOpen) {
      _window?.open(urlToOpen, '_blank')
    } else {
      const goalSection = document.getElementById('goal-selection-container')
      goalSection?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
    }
  }

  return (
    <div className={styles.container} onClick={handleBannerClick}>
      <Image
        src={isMobile ? mWebBanner : banner}
        alt='banner'
        width={isMobile ? 18 : 12}
        height={isMobile ? 5 : 1}
        layout='responsive'
        loading='lazy'
      />
    </div>
  )
}

export default NoticeBanner
